import {CommonModule, DatePipe} from '@angular/common';
import {LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {DataTableModule} from 'angular-6-datatable';
import {CalendarModule, CheckboxModule, MessageService} from 'primeng/primeng';
import {SharedModule} from '../shared.module';
import {MainRoutingModule} from './main-routing.module';
import {AgentChatComponent} from '../agent/agent-chat/agent-chat.component';
import {MasterComponent} from './master/master.component';
import {NotfoundComponent} from './notfound/notfound.component';

@NgModule({
  imports: [CommonModule, MainRoutingModule, SharedModule, FormsModule, CalendarModule, DataTableModule, NgbPaginationModule, CheckboxModule],
  exports: [NotfoundComponent, MasterComponent],
  declarations: [NotfoundComponent, MasterComponent, AgentChatComponent],
  providers: [DatePipe,MessageService, {provide: LOCALE_ID, useValue: 'tr'}],
})
export class MainModule {}
